module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/icon_incomplete_sp-332310c7d0bbf816a53a3554df8720e7.png";